import React from 'react';
import { Typography, IconButton, Dialog, DialogTitle, DialogContent, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SignUpTerms = ({ open, onClose }) => {

    return (
        < Dialog open={open} onClose={onClose}
            maxWidth="md"
            fullWidth
            sx={{
                '& .MuiDialog-paper': {
                    margin: 0,
                    height: '70%',
                    borderRadius: '20px',
                }
            }}
        >
            <DialogTitle sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '20px 15px 5px 20px',
                fontWeight: 'bold',
            }}>
                서비스 이용약관
                <IconButton aria-label="close" onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers >
                <Typography gutterBottom >
                    <strong>제1조 목적</strong><br />
                    본 약관은 클라우드 방식의 시설관리시스템 유니첵(Unicheck) 서비스를 도입함에 있어 계약사(이하 ‘회사’라 함)와 점검인(이하 ‘이용자’라 함)의 이용과 관련한
                    기본적인 사항을 정함으로써, 양자의 권리, 의무 및 책임사항, 기타 필요한 사항을 명확하게 규정, 편리하고 정확하게 이용될 수 있도록 함을 목적으로 합니다.
                </Typography>
                <Typography gutterBottom >
                    <strong>제 2조 (이용자 가입 절차)</strong><br />
                    ① 이용자가 본 약관을 읽고 “동의” 버튼을 누르거나 “확인” 등에 체크하는 방법을 취한 경우 본 약관에 동의한 것으로 간주합니다.<br />
                    ② 회사의 서비스 이용을 위한 가입은 이용자가 제1항과 같이 동의한 후, 회사가 정한 가입 신청서에 이용자 ID를 포함한 필수사항을 입력하고, “등록하기” 내지 “확인”
                    단추를 누르는 방법으로 합니다.<br />
                    ③ 이용자 ID는 휴대폰 번호로 통일하여 일괄 적용합니다.
                </Typography>
                <Typography gutterBottom >
                    <strong>제 3조 (이용자 등록의 성립과 유보 및 거절)</strong><br />
                    ① 이용자 등록은 제3조에 정한 절차에 의한 이용자 가입 신청과 회사의 이용자 등록 승낙에 의하여 성립합니다. 회사는 이용자 필수사항 등을 성실히 입력하여 가입신청을
                    완료하였을 때에는 필요한 사항을 확인한 후 지체 없이 이를 승낙을 하여야 합니다. 단 이용자 가입 신청서 제출 이외에 별도의 자료 제출이 요구되는 경우에는 예외로
                    합니다.<br />
                    ② 회사는 서비스를 제공하기에는 기술적으로 문제가 있다고 판단되는 경우에는 이용자 등록의 승낙을 유보할 수 있습니다.<br />
                    ③ 회사는 아래 각 호의 1에 해당하는 경우에는 이용자 등록을 거절할 수 있습니다.<br />
                    1. 가입신청서의 내용을 허위로 기재하였거나 허위서류를 첨부하여 가입신청을 하는 경우<br />
                    2. 기타 회사가 관련법령 등을 기준으로 하여 명백하게 사회질서 및 미풍양속에 반할 우려가 있음을 인정하는 경우
                </Typography>
                <Typography gutterBottom >
                    <strong>제 4조 (이용자 ID의 관리책임)</strong><br />
                    ① 이용자는 서비스 이용을 위한 이용자 ID, 비밀번호의 관리에 대한 책임, 본인 ID의 제3자에 의한 부정 사용 등 이용자의 고의∙과실로 인해 발생하는 모든 불이익에 대한
                    책임을 부담합니다. 단, 이것이 회사의 고의∙과실로 인하여 야기된 경우는 회사가 책임을 부담합니다.<br />
                    ② 이용자는 이용자 ID, 비밀번호 및 추가정보 등을 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 즉시 본인의 비밀번호를 수정하는 등의 조치를 취하여야 하며 즉시
                    이를 회사에 통보하여 회사의 안내를 따라야 합니다.
                </Typography>
                <Typography gutterBottom >
                    <strong>제 5조 (개인정보의 수집 등)</strong><br />
                    회사는 서비스를 제공하기 위하여 관련 법령의 규정에 따라 이용자로부터 필요한 개인정보를 수집합니다.
                </Typography>
                <Typography gutterBottom >
                    <strong>제 7조 (서비스 이용)</strong><br />
                    ① 서비스 이용은 회사의 서비스 사용 승낙 직후부터 가능합니다.<br />
                    ② 서비스 이용시간은 회사의 업무상 또는 기술상 불가능한 경우를 제외하고는 연중무휴 1일 24시간 (00:00-24:00)으로 함을 원칙으로 합니다. 다만, 서비스 설비의
                    정기점검 등의 사유로 회사가 서비스를 특정 범위로 분할하여 별도로 날짜와 시간을 정할 수 있습니다.
                </Typography>
                <Typography gutterBottom >
                    <strong>제 8조 (서비스 내용 변경 통지 등)</strong><br />
                    ① 회사가 서비스 내용이 변경되거나 서비스가 종료되는 경우 회사는 이용자의 등록된 전자우편 주소로 이메일 또는 휴대전화 등 직접 통보를 통하여 서비스 내용의 변경 사항 또는
                    종료를 통지할 수 있습니다.<br />
                    ② 전항의 경우 웹사이트 기타 회사의 공지사항 페이지를 통하여 이용자들에게 통지할 수 있습니다.
                </Typography>
                <Typography gutterBottom >
                    <strong>제 9조 (서비스 이용의 제한 및 중지)</strong><br />
                    ① 회사는 아래 각 호의 1에 해당하는 사유가 발생한 경우에는 이용자의 서비스 이용을 제한하거나 중지시킬 수 있습니다.<br />
                    1. 이용자가 보직 변경 및 휴직. 퇴사한 경우<br />
                    2. 이용자가 회사 서비스의 운영을 고의∙과실로 방해하는 경우<br />
                    3. 이용자가 제11조의 의무를 위반한 경우<br />
                    4. 서비스용 설비 점검, 보수 또는 공사로 인하여 부득이한 경우<br />
                    5. 전기통신사업법에 규정된 기간통신 사업자가 전기통신 서비스를 중지했을 경우<br />
                    6. 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 때<br />
                    7. 기타 중대한 사유로 인하여 회사가 서비스 제공을 지속하는 것이 부적당하다고 인정하는 경우<br />
                    ② 회사는 전항의 규정에 의하여 서비스의 이용을 제한하거나 중지한 때에는 그 사유 및 제한기간 등을 이용자에게 알려야 합니다.<br />
                    ③ 제13조 제2항에 의해 회사가 이용자와의 계약을 해지하고 탈퇴시키기로 결정한 경우 회사는 이용자의 탈퇴 처리 전에 이를 통지하여야 합니다.
                </Typography>
                <Typography gutterBottom >
                    <strong>제 10조 (회사의 의무)</strong><br />
                    ① 회사는 회사의 서비스 제공 및 보안과 관련된 설비를 지속적이고 안정적인 서비스 제공에 적합하도록 유지, 점검 또는 복구 등의 조치를 성실히 이행하여야 합니다.<br />
                    ② 회사는 이용자가 수신 동의를 하지 않은 영리 목적의 광고성 전자우편, SMS 문자메시지 등을 발송하지 아니합니다.<br />
                    ③ 회사는 서비스의 제공과 관련하여 알게 된 이용자의 개인정보를 본인의 승낙 없이 제3자에게 누설, 배포하지 않고, 이를 보호하기 위하여 노력합니다. 이용자의 개인정보보호에
                    관한 기타의 사항은 정보통신망법 및 회사가 별도로 정한 “개인정보 관리지침”에 따릅니다.<br />
                    ④ 회사가 제3자와의 서비스 제공 계약 등을 체결하여 이용자에게 서비스를 제공하는 경우 회사는 각 개별서비스에서 서비스의 제공을 위하여 제3자에게 제공되는 이용자의 구체적인
                    이용자정보를 명시하고 이용자의 개별적이고 명시적인 동의를 받은 후 동의의 범위 내에서 해당 서비스의 제공 기간 동안에 한하여 이용자의 개인정보를 제3자와 공유하는 등 관련
                    법령을 준수합니다.
                </Typography>
                <Typography gutterBottom >
                    <strong>제 11조 (이용자의 의무)</strong><br />
                    ① 이용자는 아래 각 호의 1에 해당하는 행위를 하여서는 아니 됩니다.<br />
                    1. 이용자 가입신청 또는 변경 시 허위내용을 등록하는 행위<br />
                    2. 회사의 서비스에 게시된 정보를 변경하거나 서비스를 이용하여 얻은 정보를 회사의 사전 승낙 없이 영리 또는 비 영리의 목적으로 복제, 출판, 방송 등에 사용하거나
                    제3자에게 제공하는 행위<br />
                    3. 회사가 제공하는 서비스를 이용하여 제3자에게 본인을 홍보할 기회를 제공 하거나 제3자의 홍보를 대행하는 등의 방법으로 금전을 수수하거나 서비스를 이용할 권리를 양도하고
                    이를 대가로 금전을 수수하는 행위<br />
                    4. 회사 기타 제3자에 대한 허위의 사실을 게재하거나 지적재산권을 침해하는 등 회사나 제3자의 권리를 침해하는 행위<br />
                    5. 다른 이용자의 ID 및 비밀번호를 도용하여 부당하게 서비스를 이용하는 행위<br />
                    6. 다른 이용자의 개인정보를 그 동의 없이 수집, 저장, 공개하는 행위<br />
                    7. 회사가 제공하는 소프트웨어 등을 개작하거나 리버스 엔지니어링, 디컴파일, 디스어셈블 하는 행위<br />
                    8. 현행 법령, 회사가 제공하는 서비스에 정한 약관 기타 서비스 이용에 관한 규정을 위반하는 행위
                </Typography>
                <Typography gutterBottom >
                    <strong>제 12조 (불만처리)</strong><br />
                    1. 회사는 개인정보와 관련하여 이용자의 의견을 수렴하고 불만을 처리하기 위한 절차를 마련하여야 합니다.<br />
                    2. 회사는 전화, 이메일 또는 위탁 고객센터를 통하여 이용자의 불만사항을 접수, 처리하여야 합니다.<br />
                    <br />
                    * 위탁 고객센터는 다음과 같습니다.<br />
                    ∎ 회 사 명: 주식회사 미디어커넥티드<br />
                    ∎ 대 표 자: 박정현<br />
                    ∎ 연 락 처: 02)2275-1071<br />
                    ∎ 주 소 지: 서울 종로구 효자로 15, 2층<br />
                    ∎ 이 메 일: mediaconnectedcs@gmail.com
                </Typography>
                <Typography gutterBottom >
                    <strong>제 13조 (이용계약의 해지)</strong><br />
                    ① 이용자가 서비스 이용계약을 해지하고자 하는 때에는 언제든지 이용자 정보관리에서 회사가 정한 절차에 따라 이용자의 ID를 삭제하고 탈퇴할 수 있습니다.<br />
                    ② 이용자가 제11조의 규정을 위반한 경우 회사는 일방적으로 본 계약을 해지할 수 있습니다
                </Typography>
                <Typography gutterBottom >
                    <strong>제 14조 (서비스의 변경)</strong><br />
                    ① 회사는 상당한 이유가 있는 경우에 회사의 정책상, 운영상, 기술상의 필요에 따라 제공하고 있는 서비스의 전부 또는 일부를 변경할 수 있으며, 이에 대하여 관련법에 특별한
                    규정이 없는 한 이용자에게 별도의 보상을 하지 않습니다.<br />
                    ② 회사는 서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등을 그 변경 전에 제10조 이용자에 대한 통지의
                    방법으로 이용자에게 통지합니다.
                </Typography>
                <Typography gutterBottom >
                    <strong>제 15조 (서비스 이용의 제한 및 정지)</strong><br />
                    ① 회사는 이용자가 본 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우 서비스 이용을 제한하거나 정지할 수 있습니다.<br />
                    ② 회사는 전항에도 불구하고 관련 법령을 위반한 명의도용, 저작권법을 위반한 불법프로그램의 제공 및 운영 방해, 정보통신망 이용촉진 및 정보보호 등에 관한 법률을 위반한
                    불법 통신, 해킹, 악성프로그램의 배포, 접속 권한 초과 행위 등과 같이 관련법을 위반한 경우에는 즉시 영구 이용 정지를 할 수 있습니다. 본 항에 따른 서비스 이용 정지
                    시 서비스 내의 혜택 및 권리 등도 모두 소멸되며 회사는 이에 대해 별도로 보상하지 않습니다.<br />
                    ③ 회사가 서비스를 제공할 수 없게 되는 경우, 회사는 제 10조 ‘이용자에 대한 통지’에 정한 방법으로 이용자에게 통지하고 서비스를 종료할 수 있습니다.
                </Typography>
                <Typography gutterBottom >
                    <strong>제 16조 (계약해지)</strong><br />
                    ① 이용자는 이용계약을 해지하고자 할 때 본인이 직접 개인정보 수정을 통하여 해지, 탈퇴하거나 이메일, 전화 등의 방법을 통하여 회사에 신청하여야 합니다.<br />
                    ② 회사는 전 1항의 규정에 의하여 해지 신청이 접수되면 즉시 이용계약을 해지합니다.<br />
                    ③ 회사는 이용자가 다음 각 호에 해당할 경우에는 이용자의 동의 없이 이용계약을 해지할 수 있으며 그 사실을 이용자에게 통지합니다. 다만 회사가 긴급하게 해지할 필요가
                    있다고 인정하는 경우나 이용자의 귀책사유로 인하여 통지할 수 없는 경우에는 지체 없이 사후 통지로 대체할 수 있습니다.<br />
                    • 이용자가 제 12조 ‘이용자의 의무’를 포함한 본 약관을 위반하고 일정기간 이내에 위반 내용을 해소하지 않은 경우<br />
                    • 회사의 서비스 제공 목적 외의 용도로 서비스를 이용하거나 제3자에게 임의로 서비스를 임대한 경우
                </Typography>
                <Typography gutterBottom >
                    <strong>제 17조 (데이터의 보존 및 파기)</strong><br />
                    ① 서비스 이용기간 만료, 서비스 이용계약의 해제 또는 해지 등의 사유로 회사가 서비스 제공을 종료한 경우 회사는 구성원의 정보를 비롯한 모든 데이터를 즉시 파기합니다.
                    단, 다음 정보들은 관련 법령에 따라 개인정보를 일정 기간 동안 보존하며, 해당 개인정보 또는 개인정보 파일을 다른 개인정보와 분리하여서 저장, 관리하고 보존기간 경과 후
                    파기 합니다.<br />
                    - 계약 등에 관한 기록<br />
                    ※ 개인정보 파기와 관련된 자세한 내용은 개인정보 처리방침에서 확인하실 수 있습니다.
                </Typography>
                <Typography gutterBottom >
                    <strong>제 18조 (규정의 준용)</strong><br />
                    본 약관에 명시되지 않은 사항에 대해서는 관련법령에 의하고, 법에 명시되지 않은 부분에 대하여는 관습에 의합니다.<br />
                    <br />
                    부칙<br />
                    본 약관은 2022년 4월 1일부터 적용됩니다. 단, 본 약관의 공지 시점으로부터 적용일 전일까지 기간 동안에 가입한 신규 이용자에 대해서는 이용자 가입시부터 본 약관이
                    적용됩니다.
                </Typography>
                <Typography gutterBottom >
                    <br /><br />
                    <strong>Unicheck<br />개인정보 처리 방침</strong><br />
                    <br />
                    1. 개인정보처리방침<br />
                    이용자는 계약사(이하“회사”)는 클라우드 방식의 시설관리시스템 유니첵(Unicheck) 서비스를 도입함에 있어 편리하고 정확하게 이용하기 위해 필요한 ‘이용자의 개인정보
                    수집ᐧ이용’에 동의하며, ‘이용자의 권리(개인정보 자기결정권)를 적극적으로 보장받았습니다.<br />
                    회사는 정보통신서비스제공자가 준수하여야 하는 대한민국의 관계 법령 및 개인정보보호 규정, 가이드라인을 준수하고 있습니다. “개인정보 처리방침”이란 이용자의 소중한 개인정보를
                    보호함으로써 이용자가 안심하고 서비스를 이용할 수 있도록 준수해야 할 지침을 의미합니다. 본 개인정보 처리 방침은 유니첵 서비스(이하 ‘유니첵’ 또는 ‘서비스’라 함)에만
                    적용됩니다.
                </Typography>
                <Typography gutterBottom >
                    2. 개인정보 수집<br />
                    서비스 이용을 위한 필요 최소한의 개인정보를 수집하고 있습니다.<br />
                    [Uniheck]<br />
                    필수<br />
                    비밀번호, 이름, 프로필사진, 전화번호<br />
                    선택<br />
                    생년월일, 성별<br />
                    [고객센터]<br />
                    필수<br />
                    전화번호, 유니첵 계정<br />
                    개인정보를 수집하는 방법은 다음과 같습니다.<br />
                    개인정보를 수집하는 경우에는 반드시 사전에 이용자에게 해당 사실을 알리고 동의를 구하고 있으며, 아래와 같은 방법을 통해 개인정보를 수집합니다.<br />
                    ᐧ 이용자 가입 과정에서 이용자가 개인정보 수집에 대해 동의를 하고 직접 정보를 입력하는 경우<br />
                        ᐧ (제휴 서비스 또는 단체로부터 개인정보를 제공받은 경우)->이용자가 입사 시 회사에 제공하고, 회사가 보유하고 있던 개인정보<br />
                    ᐧ 고객센터를 통한 상담 과정에서 수집된 정보 (웹 페이지, 메일, 팩스, 전화 등)
                </Typography>
                <Typography gutterBottom >
                    3. 개인정보 이용<br />
                    이용자 관리, 서비스 제공ᐧ개선 등을 위해 서비스 위탁 운영사에서 일괄 이용 및 운영, 관리합니다.<br />
                    <br />
                    * 서비스 위탁 운영사는 다음과 같습니다.<br />
                    ∎ 회 사 명: 주식회사 미디어커넥티드<br />
                    ∎ 대 표 자: 박정현<br />
                    ∎ 연 락 처: 02)2275-1071<br />
                    ∎ 주 소 지: 서울 종로구 효자로 15, 2층<br />
                    ∎ 이 메 일: mediaconnectedcs@gmail.com
                </Typography>
                <Typography gutterBottom >
                    이용자 가입 과정에서 홈페이지 또는 개별 어플리케이션이나 프로그램 등을 통해 아래와 같이 서비스 제공을 위해 최소한의 개인정보를 수집하고 있습니다.<br />
                    ᐧ 이용자 식별/가입의사 확인, 본인/연령 확인, 부정이용 방지<br />
                    ᐧ 동료에게 활동내용을 알리거나 이용자 검색, 등록 등의 기능 제공<br />
                    ᐧ 통계학적 특성에 따른 분석 및 서비스 제공<br />
                    ᐧ 다양한 서비스 제공, 문의사항 또는 불만처리, 공지사항 전달<br />
                    ᐧ 서비스의 원활한 운영에 지장을 주는 행위(계정 도용 및 부정 이용 행위 등 포함)에 대한 방지 및 제재<br />
                    ᐧ 서비스 이용 기록, 접속 빈도 및 서비스 이용에 대한 통계, 프라이버시 보호 측면의 서비스 환경 구축, 맞춤형 서비스 제공, 서비스 개선에 활용
                </Typography>
                <Typography gutterBottom >
                    4. 개인정보 제공<br />
                    계약사는 이용자의 별도 동의가 있는 경우나 법령에 규정된 경우를 제외하고는 이용자의 개인정보를 서비스 위탁 운영사 이외 제3자에게 제공하지 않습니다
                </Typography>
                <Typography gutterBottom >
                    5. 개인정보 파기<br />
                    개인정보는 수집 및 이용목적이 달성되면 지체 없이 파기하며, 절차 및 방법은 다음과 같습니다.<br />
                    전자적 파일 형태인 경우 복구 및 재생되지 않도록 안전하게 삭제하고, 그 밖에 기록물, 인쇄물, 서면 등의 경우 분쇄하거나 소각하여 파기합니다.
                </Typography>
                <Typography gutterBottom >
                    6. 기타<br />
                    계약사는 이용자의 권리를 보호합니다.<br />
                    언제든 자신의 개인정보를 조회하거나 수정할 수 있으며, 수집ᐧ이용에 대한 동의 철회 또는 가입해지를 요청할 수 있으나, 이 경우 서비스 이용이 제한됩니다.
                </Typography>
                <Typography gutterBottom >
                    개인정보 관리 책임자 연락처<br />
                    계약사는 개인정보 처리에 관한 업무를 총괄해서 책임지고 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 책임자를 지정하고 있습니다.<br />
                    <br />
                    계약사 관리 책임자 이메일 : manager@계약사<br />
                    <br />
                    개인정보 처리방침이 변경되는 경우<br />
                    법률이나 서비스의 변경사항을 반영하기 위한 목적으로 개인정보 처리방침을 수정할 수 있습니다. 개인정보 처리방침이 변경되는 경우 주식회사 계약사는 변경 사항을 게시하며,
                    변경된 개인정보 처리 방침은 게시한 날로부터 즉시 효력이 발생합니다.<br />
                    ᐧ 공고일자: 2022년 4월 1일<br />
                    ᐧ 시행일자: 2022년 4월 1일
                </Typography>
                <Typography gutterBottom >
                    <br /><br />
                    <strong>Unicheck<br />위치정보 수집. 이용 동의서</strong><br />
                    <br />
                    제 1조 (약관의 적용)<br />
                    1. 이용자는 계약사(이하“회사”)는 클라우드 방식의 시설관리시스템 유니첵(Unicheck) 서비스를 도입함에 있어 편리하고 정확하게 이용하기 위해 필요한 ‘이용자의 위치
                    정보를 수집ᐧ이용’을 동의하며, ‘이용자의 권리(개인정보 자기결정권)를 적극적으로 보장받았습니다.<br />
                    회사는 위치정보사업 기본 약관은 “정보통신망 이용 촉진 등에 관한 법률” 상의 개인정보보호 규정 및 정보통신부가 제정한“개인정보보호 지침” 및 “위치정보의 보호 및 이용
                    등에 관한 법률”을 준수하고 있습니다.<br />
                    2. 회사는 지정된 홈페이지(https://www.unicheck.kr)에 위치정보사업 기본 약관을 게시하는 방법으로 공지합니다.<br />
                    3. 회사의 위치정보사업 기본 약관은 위치정보사업 또는 위치기반서비스사업의 이용조건 및 절차와 이용에 필요한 기본사항을 규정합니다.
                </Typography>
                <Typography gutterBottom >
                    제 2조 (용어의 정리)<br />
                    1. “위치정보”라 함은 이동성이 있는 물건 또는 개인이 특정한 시간에 존재하거나 존재하였던 장소에 관한 정보로서 전기통신기본법 제2조 제2호 및 제3호의 규정에 따른
                    전기통신설비 및 전기통시회선설비를 이용하여 수집된 것을 말합니다.<br />
                    2. “개인위치정보”라 함은 특정 개인의 위치정보(위치정보만으로는 특정 개인의 위치를 알 수 없는 경우에도 다른 정보와 용이하게 결합하여 특정 개인의 위치를 알 수 있는
                    것을 포함한다)를 말합니다.<br />
                    3. “개인위치정보주체”라 함은 개인위치정보에 의하여 식별되는 자를 말합니다.<br />
                    4. “위치정보 수집자료 확인자료”라 함은 위치정보의 수집 요청인, 수집 일시 및 수집 방법에 관한 자료(위치정보를 제외한다)를 말합니다.<br />
                    5. “위치정보 이용ᐧ제공사실 확인자료”라 함은 위치정보를 제공받는 자, 취득 경로, 이용ᐧ제공일시 및 이용ᐧ제공방법에 관한 자료(위치정보를 제외한다)를 말합니다.<br />
                    6. “위치정보사업”이라 함은 위치정보를 수집하여 위치기반 서비스 사업자에게 제공하는 것을 사업으로 영위하는 것을 말합니다.<br />
                    7. “위치기반서비스사업”이라 함은 위치정보를 이용한 서비스(이하“위치기반서비스”라 한다)를 제공하는 것을 사업으로 영위하는 것을 말합니다.<br />
                    8. “위치정보시스템”이라 함은 위치정보사업 및 위치기반서비스사업을 위하여 정보통신망이용 촉진 및 정보 보호 등에 관한 법률 제2조 제1항 제1호의 규정에 의한 정보통신망을
                    통하여 위치정보를 수집ᐧ저장ᐧ분석ᐧ이용 및 제공할 수 있도록 서로 유기적으로 연계된 컴퓨터의 하드웨어, 소프트웨어, 데이터베이스 및 인적자원의 결합체를 말합니다.
                </Typography>
                <Typography gutterBottom >
                    제 3조 (약관의 개정)<br />
                    1. 약관의 개정이 필요한 경우, 회사는 개정한 약관을 적용하고자 하는 날(이하“효력발생일”)로부터 30일 이전에 약관이 개정된다는 사실과 개정된 내용 등을 아래에 규정된
                    방법 중 1가지 이상의 방법으로 이용자에게 고지하여 드립니다.<br />
                    ① e-mail을 통한 통보<br />
                    ② 서면 통보, 직접 통보<br />
                    ③ 홈페이지(www.unicheck.co.kr) 내 게시<br />
                    2. 회사가 e-mail 또는 서면으로 이 약관이 개정된 사실 및 개정된 내용을 이용자에게 고지하고자 하는 경우에는 이용자가 회사에 기제공한 e-mail 주소 또는 주소지
                    중 가장 최근에 제공된 e-mail 주소 또는 주소지로 통보합니다. 이용자가 회사에 제공한 e-mail 주소 또는 주소지를 수정 또는 변경하지 않음으로 인하여 개정된 약관의
                    내용을 통보 받지 못한데 대하여 어떠한 책임도 지지 않습니다.<br />
                    3. 본 조에 따라 개정된 약관(이하“개정약관”)은 원칙적으로 효력 발생일로부터 이후 개정 시까지 유효합니다.<br />
                    4. 본 조에서 정한 고지 방법 및 고지의 효력은 이 약관의 각 조항에서 규정하는 개별적인 또는 전체적인 통지의 경우에 이를 준용합니다.
                </Typography>
                <Typography gutterBottom >
                    제 4조 (계약의 성립)<br />
                    1. 위치정보사업 이용계약은 이용자의 계약과 회사의 승낙으로 이루어집니다.<br />
                    2. 이용자의 위치정보는 이용자가 회사의 업무(시설물 점검)를 수행하는 동안에만 수집되며, 그 이외의 목적으로는 사용되지 않습니다.<br />
                    3. 회사는 업무 수행상 또는 기술상 지장이 없는 경우에 그 서비스 이용을 접수합니다.<br />
                    4. 회사는 이용계약이 이루어진 경우 다음 사항을 이용자에게 통지합니다.<br />
                    ① 이용자 ID, 비밀번호 (유니첵 서비스 이용자 ID와 동일하게 적용됩니다)<br />
                    ② 서비스 제공 개시일
                </Typography>
                <Typography gutterBottom >
                    제 5조 (서비스 개요)<br />
                    1. 회사는 직접 위치정보를 수집하거나 서비스 위탁 운영사로부터 위치정보를 전달받아 아래와 같은 위치정보 사업 또는 위치기반 서비스사업을 제공합니다.<br />
                    ① GPS를 활용한 위치확인 및 위치추적: (원거리 및 실외와 같은 광범위한 공간에서) 유니첵 서비스 이용 공간 내에서 개인위치정보 주체의 위치정보와 이동 동선 정보가
                    저장됩니다.<br />
                    ② 위치정보를 활용한 시간 정보 제공: 개인위치정보주체의 실내, 실외 위치정보를 수집하여 이동 동선 및 동선별 체류시간 또는 이동시간을 측정하여 제공합니다.<br />
                    ③ 위치정보를 활용한 대상 찾기: 현재 위치를 활용하여 같은 서비스를 이용하고 있는 사용자 또는 이동성 있는 기기의 실시간 위치를 확인할 수 있습니다.<br />
                        ④ 위치정보의 공유: 개인위치정보주체 또는 이동성 있는 기기의 위치정보를 서비스의 원활한 이용 등의 목적으로 (지인 또는 개인위치정보 주체가)->회사가 지정한 서비스 운영
                    위탁사에게 공유합니다.
                </Typography>
                <Typography gutterBottom >
                    2. 서비스 운영 위탁사는 다음과 같습니다.<br />
                    ∎ 회 사 명: 주식회사 미디어커넥티드<br />
                    ∎ 대 표 자: 박정현<br />
                    ∎ 연 락 처: 02)2275-1071<br />
                    ∎ 주 소 지: 서울 종로구 효자로 15, 2층<br />
                    ∎ 이 메 일: mediaconnectedcs@gmail.com
                </Typography>
                <Typography gutterBottom >
                    제 6조 (서비스의 이용시간 및 중지)<br />
                    서비스의 이용시간은 회사의 업무상 및 기술상 특별한 지장이 없는 한 이용자의 업무시간 내 수집을 연중무휴 1일 24시간을(삭제) 원칙으로 합니다.
                </Typography>
                <Typography gutterBottom >
                    제 7조 (개인위치정보 수집, 이용, 제공에 대한 동의 철회)<br />
                    이용자가 개인위치정보의 수집, 이용, 제공에 대한 동의철회 시 회사는 즉각적으로 이를 수행할 의무가 있습니다. 단, 이용자가 개인정보의 수집, 이용, 제공에 대한 동의 철회
                    시 회사는 양자 간 모든 계약의 해지 및 철회를 요구하는 것으로 간주할 수 있습니다.
                </Typography>
                <Typography gutterBottom >
                    제 8조 (개인위치정보 수집에 대한 동의)<br />
                    1. 회사는 원활한 서비스 제공 및 이용자가 사전에 동의한 서비스의 제공을 위하여 개인위치정보주체의 동의 하에 개인 위치정보를 수집합니다.<br />
                    2. 회사는 개인위치정보를 수집하는 경우 수집목적을 달성하기 위하여 필요한 최소한의 정보를 수집합니다.
                </Typography>
                <Typography gutterBottom >
                    제 9조 (개인위치정보의 보유기간 및 이용기간)<br />
                    1. 회사는 위치정보의 수집, 이용, 제공 사실 확인자료를 위치정보시스템에 자동으로 기록하고 보존합니다.<br />
                    2. 이용자의 위치정보는 회사의 위치정보시스템에 1년간 기록ᐧ저장되며, 수집, 이용, 제공사실 확인자료 외 1년이 지난 위치데이터는 개인에게 사전통보 없이 영구 삭제됩니다.
                </Typography>
                <Typography gutterBottom >
                    제 10조 (긴급구조를 위한 개인위치정보의 제공)<br />
                    1. 재난 또는 재해 위험 지역 안에 있는 개인에게, 생명, 신체의 위험을 알리기 위해 긴급구조기관이 위치정보사업자에게 경보 발송을 요청하는 경우 회사는 이를 고지할 의무가
                    있습니다.<br />
                    2. 긴급구조 기관 소방청, 소방본부 및 소방서 또는 해양경찰청, 해양경찰서 등에서 위치정보요청이 있을 경우 회사는 이를 고지할 의무가 있습니다.
                </Typography>
                <Typography gutterBottom >
                    제 11조 (면책 조항)<br />
                    1. 회사는 서비스를 통해 전달되는 자료의 정확성 또는 내용에 대해 일체의 책임을 지지 않습니다.<br />
                    2. 회사는 통신사 서버 또는 통신 중개업체의 과실로 인한 서비스 불완전으로 발생한 피해는 책임지지 않습니다.<br />
                    3. 회사는 이용자가 유포한 불법 자료나 저작권과 관련된 자료로 입을 수 있는 피해에 대하여 일체의 책임을 지지 않습니다.<br />
                    4. 회사는 의무를 다했을 경우에 발생하는 피해에 대해서는 일체의 책임을 지지 않습니다.<br />
                    5. 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임이 없습니다.<br />
                    6. 회사는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여 그 어떠한 책임도 지지 않습니다.<br />
                    7. 회사는 이용자가 서비스를 이용하여 기대되는 손익이나 서비스를 통하여 얻은 자료로 인한 손해에 관하여는 그 어떠한 책임도 지지 않습니다.<br />
                    8. 회사는 이용자 상호간 또는 이용자와 제3자간에 발생한 분쟁에 대해서는 개입할 의무가 없으며 이로 인한 손해에 대해서는 일체의 책임을 지지 않습니다.<br />
                    9. 이용자가 본 약관의 규정을 위반하여 발생되는 손해에 대해서 해당 이용자는 회사에 발생하는 모든 손해를 배상하여야 하며, 동 손해와 관련된 분쟁으로부터 회사를 면책시켜야
                    합니다.
                </Typography>
                <Typography gutterBottom >
                    제 12조 (분쟁의 조정 등에 관한 사항)<br />
                    1. 위치정보와 관련하여 분쟁이 있을 경우 정보통신망이용촉진 및 정보보호 등에 관한 법률 제33조의 규정에 의한 개인정보 분쟁 조정위원회에 분쟁조정을 신청할 수 있으며,
                    관할 법원기관에서의 진행을 원칙으로 합니다.<br />
                    2. 회사와 이용자 간에 제기된 정보통신 관련법 소송에는 한국 법을 적용합니다.<br />
                    3. 회사는 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리 일정을 즉시 통보합니다.
                </Typography>
            </DialogContent>
        </Dialog >
    );
}

export default SignUpTerms;